import { FS_CLIENT_LOGOUT_TIMEOUT } from '#constants';
const activeFilespaceClientsRecords = new Map();
const onClientLogin = (key) => {
    const record = activeFilespaceClientsRecords.get(key);
    if (record?.timeoutId) {
        clearTimeout(record.timeoutId);
    }
    activeFilespaceClientsRecords.set(key, {
        activeCalls: (record?.activeCalls ?? 0) + 1,
        timeoutId: null,
    });
};
const onClientCallFinished = (clientId, logout) => {
    const record = activeFilespaceClientsRecords.get(clientId);
    // Entering here means a flaw in the logic:
    if (!record) {
        // eslint-disable-next-line no-console -- Debug
        console.warn(`FSC missing record: ${clientId}`);
        return;
    }
    const activeCalls = record.activeCalls - 1;
    activeFilespaceClientsRecords.set(clientId, { ...record, activeCalls });
    // Not the last call — keep the client logged in.
    if (activeCalls > 0) {
        return;
    }
    const timeoutId = setTimeout(() => {
        // A new call arrived in the meantime — do not log out.
        if (activeFilespaceClientsRecords.get(clientId)?.activeCalls) {
            return;
        }
        void logout()
            // eslint-disable-next-line no-restricted-syntax -- callback is () => void
            .catch(() => {
            // eslint-disable-next-line no-console -- Debug
            console.error(`FSC failed logout: ${clientId}`);
        });
    }, FS_CLIENT_LOGOUT_TIMEOUT);
    activeFilespaceClientsRecords.set(clientId, { activeCalls, timeoutId });
};
export const plugFilespaceClientInternal = async ({ action, clientId, loginClient, logoutClient, }) => {
    const fsClient = await loginClient();
    onClientLogin(clientId);
    try {
        return await action(fsClient);
    }
    finally {
        onClientCallFinished(clientId, logoutClient);
    }
};
